import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';

import { MerchantStore } from '../../feature/merchant/merchant.store';
import { EnvironmentService } from '../environment/environment.service';

/**
 * Ensures the merchant is initialized. Must be called within an injection context.
 */
export const onMerchantInitialized = () => {
	const merchant = inject(MerchantStore);
	const environment = inject(EnvironmentService);

	if (environment.store.includes('localhost') || !environment.store) return;

	return toObservable(merchant.initialized).pipe(
		filter((initialized) => initialized),
		take(1)
	);
};
